import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { FlowLogo } from '@flow/components/logo/FlowLogo';
import { NavLink, withSiteData } from 'react-static';
import { getRelativeUrl } from '@flow/utils/cleaners';
import em from 'polished/lib/helpers/em';

const LogoWrapper = styled.div`
  margin: 5em 0 10em;
  
  @media only screen and (max-width: ${props => props.theme.narrowOverlayNavPoint}px) {
    margin: 8em 0 3em;
  }
  
  @media only screen and (max-width: 400px) {
    margin: 3em 0 3em;
  }
`;

const NavigationInnerWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

const LanguageNavItemsContainer = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

const TopLevelNavItemContainer = styled.li`
  padding: 4em;
`;

const TopLevelNavItem = styled.span`
  display: block;
  margin-bottom: 0.6em;
  text-transform: uppercase;
  
  a {
    font-size: 3.4em;
    font-family: Flow-Poster-Bold;
    
    &:${props => props.theme.hoverProperty} {
      color: white;
    }
  }
`;

const SubLevelNavItemContainer = styled.ul`
  //margin-top: 2.8em;
`;

const SubLevelNavItem = styled.li`
  text-transform: uppercase;

  a {
    display: block;
    font-size: 2.8em;
    line-height: ${em(3.4, 2.8)};
    padding: ${em(0.6, 2.8)} 0;
    
    &:${props => props.theme.hoverProperty} {
      color: white;
    }
  }
`;

const TopLevelNavItemsContainer = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
  
  @media only screen and (max-width: ${props => props.theme.mediumOverlayNavPoint}px) {
    font-size: 80%;
    
    ${SubLevelNavItem} {
      a {
        padding: ${em(1, 2.8)} 0;
      }
    }
    
    ${TopLevelNavItem} {
      margin-bottom: 1.5em;
    }
  }
  
  @media only screen and (max-width: ${props => props.theme.narrowOverlayNavPoint}px) {
    display: block;
    ${NavigationInnerWrap} {
      display: block;
    }
    
    ${TopLevelNavItemContainer} {
      padding: 2em;
    }
  }
  
  @media only screen and (max-width: 500px) {
    font-size: 65%;
  }
`;

interface Props {
  appLanguage: IAppLanguage;
  navigation: any;
  settings: ISettings;
  languages: any;
}

class _OverlayNavigationList extends React.Component<Props> {

  _parseCorrectNavByLang(appLanguage: IAppLanguage, navigation: any) {
    return navigation[appLanguage.code];
  }

  _renderSubLevelItem = (navItem: any, key: any) => {
    return (
      <SubLevelNavItem key={key}>
        <NavLink to={ getRelativeUrl(navItem.url) }>
          { navItem.title }
        </NavLink>
      </SubLevelNavItem>
    );
  };

  _renderTopLevelItem = (navItem: any, key: any) => {
    return (
      <TopLevelNavItemContainer key={key}>
        <TopLevelNavItem>
          <NavLink to={ getRelativeUrl(navItem.url) }>
            { navItem.title }
          </NavLink>
        </TopLevelNavItem>
        { Boolean(navItem.children.length) && <SubLevelNavItemContainer className={'sub-level-naviagtion'}>
          { navItem.children.map(this._renderSubLevelItem) }
        </SubLevelNavItemContainer> }
      </TopLevelNavItemContainer>
    )
  };

  _renderTopLevelItems = (navigation: any) => {
    return  (
      <TopLevelNavItemsContainer>
        { navigation.map(this._renderTopLevelItem) }
      </TopLevelNavItemsContainer>
    );
  };

  _renderLanguageNavItems = (appLanguage: IAppLanguage, languages: any, settings: any) => {

    const languageKeys = Object.keys(languages);
    const defaultLangCode = settings.languages['default'];
    const availableLanguages = languageKeys.filter(lang => lang !== appLanguage.code);

    return (
      <LanguageNavItemsContainer>
        <TopLevelNavItemContainer>
          <TopLevelNavItem>
            { languages[appLanguage.code].name }
          </TopLevelNavItem>
          <SubLevelNavItemContainer className={'sub-level-naviagtion'}>
            { availableLanguages.map((lang, key) =>
              <SubLevelNavItem key={key}>
                <NavLink to={lang === defaultLangCode ? '/' : `/${languages[lang].code}`}>
                  { languages[lang].name }
                </NavLink>
              </SubLevelNavItem>)
            }
          </SubLevelNavItemContainer>
        </TopLevelNavItemContainer>
      </LanguageNavItemsContainer>
    );
  };

  render () {

    const {
      appLanguage,
      navigation
    } = this.props;

    const languageNav = this._parseCorrectNavByLang(appLanguage, navigation);

    return <NavigationInnerWrap>
      <LogoWrapper>
        <FlowLogo appLanguage={appLanguage} highlightColor={'#FFFFFF'} />
      </LogoWrapper>
      { this._renderTopLevelItems(languageNav) }
    </NavigationInnerWrap>
  }
}

const NavigationListWithProps = withSiteData(_OverlayNavigationList);

const _Navigation = ({ appLanguage }: Props & RouteComponentProps<{}>) => {
  return (
    <NavigationListWithProps appLanguage={appLanguage} />
  )
};

const OverlayNavigationList = withRouter(_Navigation);

export default OverlayNavigationList;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/navigation/OverlayNavigationList.tsx